import { FC } from 'react'

import Stack, { StackProps } from '@mui/material/Stack'

export const FlowViewActions: FC<StackProps> = ({ children, ...rest }) => (
  <Stack direction={'column'} gap={3} pt={2} {...rest}>
    {children}
  </Stack>
)
